import { createContext, useContext, useState } from "react";

const AdminAuthContext = createContext(null);
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function AdminAuthProvider({ children }) {
  const [admin, setAdmin] = useState(() => {
    const stored = localStorage.getItem("kybia_admin");
    try { return stored ? JSON.parse(stored) : null; } catch { return null; }
  });

  const isAuthenticated = !!admin;

  const login = async (email, password) => {
    try {
      const res = await fetch(`${BACKEND_URL}/api/admin/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();
      if (!res.ok) return { success: false, error: data.detail || "Invalid credentials" };
      localStorage.setItem("kybia_admin", JSON.stringify(data));
      setAdmin(data);
      return { success: true };
    } catch {
      return { success: false, error: "Connection error. Please try again." };
    }
  };

  const logout = () => {
    localStorage.removeItem("kybia_admin");
    setAdmin(null);
  };

  return (
    <AdminAuthContext.Provider value={{ isAuthenticated, admin, login, logout }}>
      {children}
    </AdminAuthContext.Provider>
  );
}

export function useAdminAuth() {
  return useContext(AdminAuthContext);
}
